import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Route, Routes } from 'react-router-dom';
import Protected from './Protected';
import { protectedRoutes } from './ProtectedRoutes';
import SignIn from './components/Layout/Login';
import { useEffect } from 'react';
import Swal from 'sweetalert2';
import { store } from './Redux/store';
import { setBranchCode } from './Redux/Services/headerSlice';
import Tracking from './components/Query/Tracking';
import ForgotPassword from './components/Layout/ForgotPassword';
import { getActiveProject } from './components/CommonComponents/ProjectConfig';

const activeProject = getActiveProject();
document.title = activeProject.name;

export const App = () => {
    const theme = createTheme();
    
    useEffect(() => {
        // Apply dynamic project theme
        const t = activeProject.theme;
        if (t) {
            const root = document.documentElement;
            root.style.setProperty('--brand-primary', t.primary);
            root.style.setProperty('--brand-dark', t.primaryDark);
            root.style.setProperty('--brand-light', t.primaryLight);
            root.style.setProperty('--brand-lighter', t.primaryLighter);
            root.style.setProperty('--brand-text', t.primaryText);
            root.style.setProperty('--brand-accent', t.accent);
            root.style.setProperty('--brand-hover', t.accentHover);
            root.style.setProperty('--theme-color', t.primary);
            root.style.setProperty('--mycolorMain', t.primary);
            root.style.setProperty('--mycolorTable', t.primaryLight);
            root.style.setProperty('--mycolorFilterCheckText', t.accent);
        }
    }, []);

    useEffect(() => {
        const handleStorageChange = (event) => {
            if (event.key === 'branch_change') {
                Swal.fire({
                    text: "You changed the Branch in another tab so your page will reload !",
                    icon: 'warning',
                    title: "Warning !",
                    iconColor: '#ec8601',
                    color: "#ec8601",
                    confirmButtonColor: "#ec8601",
                    width: 500,
                    customClass: {
                        confirmButton: 'bg-yellow-500 text-white px-4 py-2 rounded me-2',
                        cancelButton: 'bg-red-500 text-white px-4 py-2 rounded'
                    },
                    didClose: () => {
                        window.location.reload()
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.location.reload()
                        const newBranch = localStorage.getItem('branch_value');
                        if (newBranch) {
                            store.dispatch(setBranchCode(newBranch));
                        }
                    }
                });
            }
        };

        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);






    const handleCancel = async (value, item) => {

    }
    return (
        <ThemeProvider theme={theme}>
            <Routes>
                <Route path="/login" element={<SignIn />} />
                <Route path="/" element={<SignIn />} />
                <Route path="/ForgotPassword" element={<ForgotPassword />} />
                <Route path="/Tracking" element={<Tracking />} />
                {protectedRoutes?.map((route, index) => {
                    const Component = route.component;
                    return (
                        <Route
                            key={index}
                            path={route.path}
                            element={
                                <Protected
                                    Component={Component} path={route.path}
                                />
                            }
                        />
                    );
                })}
            </Routes>
        </ThemeProvider>
    );
};